import React from 'react';
import { Tabs } from '@opendate-app/setlist';

const FinanceTabs = ({ tabs = [], activeValue }) => {
  if (tabs.length === 0) return null;

  const handleChange = (value) => {
    const tab = tabs.find((candidate) => candidate.value === value);
    if (tab && tab.href && value !== activeValue) window.location.assign(tab.href);
  };

  return (
    <Tabs
      aria-label="Finance sections"
      collapseBelow={0}
      value={activeValue}
      onChange={handleChange}
      items={tabs.map(({ value, label, count }) => (count ? { value, label, count } : { value, label }))}
    />
  );
};

export default FinanceTabs;
